import { Components, Theme } from '@mui/material/styles';

export const MuiTabPanel: Components<Omit<Theme, 'components'>>['MuiTabPanel'] = {
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
};
